import { localStorageService } from '@Engage.Data/services/storage/localStorage/LocalStorageService';
import { StorageKeys } from '@Engage.Data.Constants';
export class VisitedView {
    constructor() {
        this.visitedDates = [];
        this.currentDate = Date.now();
        this.visitedDates = this.loadVisitedDates();
        this.recordVisitIfNewDay();
    }
    setCurrentDate(date) {
        this.currentDate = date.valueOf();
    }
    getCurrentDate() {
        return this.currentDate;
    }
    /**
     * Returns the number of distinct days visited within the last `days` days
     * (inclusive of today).
     *
     * e.g. getVisitedViewsByDays(7) → visits from 7 days ago up to and including now
     */
    getVisitedViewsByDays(days) {
        const now = Date.now();
        // when days is MAX_SAFE_INTEGER return total count of all recorded visits
        if (days === Number.MAX_SAFE_INTEGER) {
            return this.visitedDates.length;
        }
        const startOfToday = this.getStartOfDay(now);
        const startPeriod = startOfToday - (days - 1) * 86400000;
        return this.visitedDates.filter(d => d >= startPeriod && d <= now).length;
    }
    // ─── Private ─────────────────────────────────────────────────────────────
    loadVisitedDates() {
        try {
            const stored = localStorageService.get(StorageKeys.VisitedView, {
                expandKey: false,
                isJson: true
            });
            return Array.isArray(stored) ? stored : [];
        }
        catch (_a) {
            return [];
        }
    }
    recordVisitIfNewDay() {
        const todayStart = this.getStartOfDay(this.currentDate);
        // check if we already have a visit recorded for today
        const alreadyVisitedToday = this.visitedDates.some(d => d >= todayStart && d < todayStart + 86400000);
        if (!alreadyVisitedToday) {
            this.visitedDates.push(this.currentDate);
            this.save();
        }
    }
    getStartOfDay(timestamp) {
        const d = new Date(timestamp);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate()).valueOf();
    }
    save() {
        localStorageService.set(StorageKeys.VisitedView, this.visitedDates, {
            expandKey: false,
            isJson: true
        });
    }
}
